import { memo } from 'react';
import {
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
} from '@chakra-ui/react';
import { FiCode } from 'react-icons/fi';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodePopover = memo(({ code }) => (
  <Popover trigger="hover" placement="right">
    <PopoverTrigger>
      <IconButton
        aria-label="Show code"
        icon={<FiCode />}
        variant="ghost"
        size="sm"
      />
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverCloseButton />
      <PopoverBody p={0}>
        <SyntaxHighlighter
          language="typescript"
          style={oneDark}
          customStyle={{ margin: 0 }}
        >
          {code}
        </SyntaxHighlighter>
      </PopoverBody>
    </PopoverContent>
  </Popover>
));

export default CodePopover; 